import { gql } from "@apollo/client";

export const CREATE_MISSION = gql`
    mutation createMission($data: CreateMissionInput!) {
        createMission(data: $data) {
            id
            name
            start_date
            end_date
            city
            is_actived
            is_deleted
        }
    }
`;

export const UPDATE_MISSION = gql`
    mutation updateMission($data: UpdateMissionInput!) {
        updateMission(data: $data) {
            id
            name
            start_date
            end_date
            city
            is_actived
            is_deleted
        }
    }
`;

export default CREATE_MISSION;
